var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkNewTab = function SvgLinkNewTab(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2917 10.2917H2.70833V2.70833H6.5V1.625H2.70833C2.42102 1.625 2.14547 1.73914 1.9423 1.9423C1.73914 2.14547 1.625 2.42102 1.625 2.70833V10.2917C1.625 10.579 1.73914 10.8545 1.9423 11.0577C2.14547 11.2609 2.42102 11.375 2.70833 11.375H10.2917C10.8875 11.375 11.375 10.8875 11.375 10.2917V6.5H10.2917V10.2917ZM7.58333 1.625V2.70833H9.52792L4.20333 8.03292L4.96708 8.79667L10.2917 3.47208V5.41667H11.375V1.625H7.58333Z",
    fill: "#52C3F9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkNewTab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LinkNewTab.aa0d9aca969978d43573d0fe5ba0631c.svg";